export default __webpack_public_path__ + "static/media/hoi.9c172b4a.svg";